module.exports = __webpack_public_path__ + "img/serv-college.c3d1e444.jpg";